import { createStyles, Grid, IconButton, makeStyles, Theme } from "@material-ui/core";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import useLandingFunctions from "../../../../../hooks/useLandingFunctions";
import { PFXBasicComponent } from "../../../../../models/Interfaces";
import { selectIsMobile } from "../../../../../redux/slices/cleverlynkSlice";
import { selectComponentDimensions } from "../../../../../redux/slices/landingSlice";
import { IKImage } from "imagekitio-react";
import { MARGIN_BASE } from "../../../../../pages/Landing";

interface ICarousel {
  id: string;
  data: PFXBasicComponent;
}

const Carousel = ({ id, data }: ICarousel) => {
  const { width, height } = useSelector(selectComponentDimensions);
  const isMobile = useSelector(selectIsMobile);

  const [activeSlide, setActiveSlide] = useState<number>(0);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      container: {
        width,
        position: "relative",
        height: "100%",
      },
      root: {
        position: "relative",
        height: !isMobile ? height * (data.heightMultiplier ?? 1) * 1.7 : height * (data.heightMultiplier ?? 1),
        transition: "height 400ms",
        backgroundColor: data.backgroundColor ?? "#ffffff",
        padding: `${(data?.margins?.y ?? 2) * MARGIN_BASE}px ${(data?.margins?.x ?? 2) * MARGIN_BASE}px`,
      },
      image: {
        position: "absolute",
        top: 0,
        // height: !isMobile ? height * (data.heightMultiplier ?? 1) * 1.7 : height * (data.heightMultiplier ?? 1),
        height: "100%",
        width: `calc(${width}px - ${(data?.margins?.y ?? 2) * MARGIN_BASE * 2}px)`,
        maxWidth: 1000,
        objectFit: "cover",
        opacity: 0,
        transitionProperty: "opacity",
        transitionDuration: "400ms",
        transform: "translateX(-50%)",
        left: "50%",
        "&.selected": {
          opacity: 1,
        },
      },
      arrow: {
        backgroundColor: "white",
        color: "#1a1a1a",
        padding: 2,
      },
      arrowsDiv: {
        width: "100%",
        height: "100%",
        position: "relative",
        padding: 8,
        maxWidth: 1000,
      },
    })
  );

  const classes = useStyles();

  const handleArrowClick = (mod: number) => {
    const ns = activeSlide + mod;
    if (ns >= (data?.images ?? []).length) {
      setActiveSlide(0);
    } else if (ns < 0) {
      setActiveSlide((data?.images ?? []).length - 1);
    } else setActiveSlide(ns);
  };

  return (
    <Grid container justifyContent="center" alignItems="center" className={classes.root} id={`landing-component-${id}`}>
      <Grid container justifyContent="center" alignItems="center" className={classes.container}>
        {data.images?.map((i, index) => {
          return (
            <IKImage
              id={`carousel-${i.url}`}
              key={`carousel-${i.url}`}
              className={`${activeSlide === index ? "selected" : ""} ${classes.image}`}
              path={(i?.url ?? "").split("cleverlynk-imgs.s3.amazonaws.com")[1]}
              loading="lazy"
              lqip={{ active: true, quality: 20, blur: 10 }}
            />
          );
        })}
        {(data?.images ?? []).length > 1 && (
          <Grid container alignItems="center" justifyContent="space-between" className={classes.arrowsDiv}>
            <React.Fragment>
              <IconButton className={classes.arrow} onClick={() => handleArrowClick(-1)}>
                <KeyboardArrowLeft />
              </IconButton>
              <IconButton className={classes.arrow} onClick={() => handleArrowClick(1)}>
                <KeyboardArrowRight />
              </IconButton>
            </React.Fragment>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
export default Carousel;
